module.exports = __webpack_public_path__ + "img/圆.d2a05c21.svg";